<div class="container under-construction">
    <div class="row no-gutters">
        <div class="col-12 d-flex align-items-start justify-content-center">
            <h1>In opbouw</h1>
        </div>
    </div>
</div>